export const UploadingMethods = {
  None: 0,
  File: 1,
  Ftp: 2,
  Cloud: 4,
  Any: 7,
};

export const UploadingTypes = {
  Image: 1,
  Video: 2,
  Any: 3,
};

export const DefaultFileExtensions = 'gif,jpg,jpeg,png,webp,mp4,webp,jfif';
export const DefaultFileAccepts = 'image/png,image/gif,image/jpeg,image/webp,video/mp4';
